import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-facing-decorator';
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
let ExamQuizScore = class ExamQuizScore extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isScorm", void 0);
    _defineProperty(this, "successRate", void 0);
    _defineProperty(this, "scoreToContinue", void 0);
    _defineProperty(this, "remainingTries", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "isSpeachTemplate", void 0);
  }
  get isSuccess() {
    return this.successRate >= this.scoreToContinue;
  }
  get iconClass() {
    return this.isSuccess ? 'check-circle-outline' : 'close-circle-outline';
  }
  get iconColorClass() {
    return this.isSuccess ? 'success' : 'failure';
  }
};
__decorate([Prop({
  required: true
})], ExamQuizScore.prototype, "isScorm", void 0);
__decorate([Prop({
  required: true
})], ExamQuizScore.prototype, "successRate", void 0);
__decorate([Prop({
  required: true
})], ExamQuizScore.prototype, "scoreToContinue", void 0);
__decorate([Prop({
  default: 0
})], ExamQuizScore.prototype, "remainingTries", void 0);
__decorate([Prop({
  default: false
})], ExamQuizScore.prototype, "canEdit", void 0);
__decorate([Prop({
  default: false
})], ExamQuizScore.prototype, "isSpeachTemplate", void 0);
ExamQuizScore = __decorate([Component({
  components: {
    QuizReadonlyAlert
  }
})], ExamQuizScore);
export default ExamQuizScore;